const BlogCategory: string = "Blog";
export default BlogCategory;
